<template>
    <div>
        <loading
            :active.sync="loadingContent"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Channel Komunitas</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <!-- <ul class="listview image-listview inset m-2">
                <li>
                    <a
                        href="https://whatsapp.com/channel/0029VaaZwz21iUxZG2jeOT1I"
                        target="_blank"
                        class="item"
                    >
                        <div
                            class="icon-box"
                            style="background-color: #128c7e; color: white"
                        >
                            <ion-icon name="logo-whatsapp"></ion-icon>
                        </div>
                        <div class="in">
                            <div>WhatsApp Channel</div>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        href="https://t.me/qiosfincom"
                        target="_blank"
                        class="item"
                    >
                        <div
                            class="icon-box"
                            style="background-color: #229ed9; color: white"
                        >
                            <ion-icon name="send-outline"></ion-icon>
                        </div>
                        <div class="in">
                            <div>Telegram Channel</div>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        href="https://facebook.com/qiosfincom"
                        target="_blank"
                        class="item"
                    >
                        <div
                            class="icon-box"
                            style="background-color: #3b5998; color: white"
                        >
                            <ion-icon name="logo-facebook"></ion-icon>
                        </div>
                        <div class="in">
                            <div>Facebook Fans Page</div>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        href="https://instagram.com/qiosfin.official"
                        target="_blank"
                        class="item"
                    >
                        <div
                            class="icon-box"
                            style="background-color: #e1306c; color: white"
                        >
                            <ion-icon name="logo-instagram"></ion-icon>
                        </div>
                        <div class="in">
                            <div>Instagram</div>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.youtube.com/@qiosfin.official"
                        target="_blank"
                        class="item"
                    >
                        <div
                            class="icon-box"
                            style="background-color: #c4302b; color: white"
                        >
                            <ion-icon name="logo-youtube"></ion-icon>
                        </div>
                        <div class="in">
                            <div>Youtube</div>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.tiktok.com/@qiosfin.official"
                        target="_blank"
                        class="item"
                    >
                        <div
                            class="icon-box"
                            style="background-color: #000000; color: white"
                        >
                            <ion-icon name="logo-tiktok"></ion-icon>
                        </div>
                        <div class="in">
                            <div>Tiktok</div>
                        </div>
                    </a>
                </li>
            </ul> -->
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                loadingContent: true,
            };
        },
        created() {
            setTimeout(() => {
                this.loadingContent = false;
            }, 300);
        },
        mounted() {
            document.body.classList.remove('bg-white');
        },
    };
</script>
